/* Smartpharm information theme. No cart, checkout or purchase code. */
(() => {
  'use strict';
  const $ = (s,r=document) => r.querySelector(s);
  const $$ = (s,r=document) => [...r.querySelectorAll(s)];
  const text = JSON.parse($('#ui-strings')?.textContent || '{}');
  const config = window.SMARTPHARM_CONFIG;
  const motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
  const motionAllowed = () => !motionPreference.matches && document.body.dataset.motion !== 'false' && !window.Shopify?.designMode;
  let observer;
  function closeMenu(focus=false) {
    const nav=$('#mobile-nav'),button=$('.menu-toggle');
    if(nav) nav.hidden=true;
    button?.setAttribute('aria-expanded','false');
    if(focus) button?.focus();
  }
  function hours() {
    if(!config || !window.SmartpharmUtils) return;
    const state=window.SmartpharmUtils.openingState(new Date(),config);
    $$('[data-hours-status]').forEach(el=>{
      el.classList.toggle('closed',!state.open);
      el.textContent=state.open ? `${text.status[0]} · ${text.closeAt} ${state.closesAt}` : text.status[1];
    });
  }
  function applyFilter(group,category) {
    let count=0;
    $$('[data-service]',group).forEach(card=>{
      card.hidden=category!=='all' && card.dataset.category!==category;
      if(!card.hidden){count++;card.classList.add('is-visible');}
    });
    $$('[data-filter]',group).forEach(button=>{
      button.classList.toggle('active',button.dataset.filter===category);
      button.setAttribute('aria-pressed',String(button.dataset.filter===category));
    });
    const counter=$('.result-count',group);if(counter)counter.textContent=`${count} ${text.count}`;
  }
  function init(root=document) {
    $$('[data-tracking] fieldset',root).forEach(el=>el.disabled=false);
    $$('[data-year]',root).forEach(el=>el.textContent=new Date().getFullYear());
    $$('.desktop-nav a, .mobile-nav a',root).forEach(a=>{
      const active=new URL(a.href,location.href).pathname.replace(/\/$/,'')===location.pathname.replace(/\/$/,'');
      if(active)a.setAttribute('aria-current','page');else a.removeAttribute('aria-current');
    });
    const subject=$('#subject',root),requested=new URLSearchParams(location.search).get('subject');
    if(subject && requested!==null){const selected=$(`[data-subject="${Number(requested)}"]`,subject);if(selected)subject.value=selected.value;}
    if(motionAllowed() && 'IntersectionObserver' in window){
      document.body.classList.add('motion-ready');
      observer ??= new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target);}}),{threshold:.07,rootMargin:'0px 0px 30px'});
      $$('.section-heading, .split-section, .product-visual-stack, .responsible-pharmacist',root).forEach(el=>el.classList.add('reveal'));
      $$('.service-grid, .post-services, .values-grid, .steps',root).forEach(group=>[...group.children].forEach((el,i)=>el.style.setProperty('--reveal-delay',`${i%3*70}ms`)));
      $$('.reveal',root).forEach(el=>observer.observe(el));
    }else{
      document.body.classList.remove('motion-ready');observer?.disconnect();
      $$('.reveal',root).forEach(el=>el.classList.add('is-visible'));
    }
    hours();updateScroll();
  }
  document.addEventListener('click',event=>{
    const toggle=event.target.closest('.menu-toggle');
    if(toggle){const open=toggle.getAttribute('aria-expanded')!=='true';const nav=$('#mobile-nav');if(nav)nav.hidden=!open;toggle.setAttribute('aria-expanded',String(open));if(open)$$('.language-picker').forEach(p=>p.open=false);}
    else if(!event.target.closest('.site-header'))closeMenu();
    if(!event.target.closest('.language-picker'))$$('.language-picker').forEach(p=>p.open=false);
    const filter=event.target.closest('[data-filter]');
    if(filter)applyFilter(filter.closest('.services-section'),filter.dataset.filter);
    if(event.target.closest('[data-privacy]'))$('#privacy-dialog')?.showModal();
    if(event.target.closest('.dialog-close'))$('#privacy-dialog')?.close();
    if(event.target.closest('.back-top'))window.scrollTo({top:0,behavior:motionAllowed()?'smooth':'auto'});
    if(event.target.id==='privacy-dialog'){
      const r=event.target.getBoundingClientRect();
      if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)event.target.close();
    }
  });
  document.addEventListener('keydown',event=>{if(event.key==='Escape'){if($('#mobile-nav') && !$('#mobile-nav').hidden)closeMenu(true);$$('.language-picker').forEach(p=>p.open=false);}});
  document.addEventListener('input',event=>{if(event.target.matches('[data-tracking] input'))event.target.setCustomValidity('');});
  document.addEventListener('submit',event=>{
    const form=event.target;
    if(form.matches('[data-tracking]')){
      event.preventDefault();const input=$('input',form);
      const url=window.SmartpharmUtils.trackingLink(input.value,document.body.dataset.lang);
      input.setCustomValidity(url?'':text.trackingError);
      if(form.reportValidity()&&url)location.assign(url);
    }
    // Shopify contact/localization forms submit normally. Never intercept or fake success.
  });
  document.addEventListener('toggle',event=>{if(event.target.matches('.faqs details')&&event.target.open)$$('details',event.target.parentElement).forEach(d=>{if(d!==event.target)d.open=false;});},true);
  function revealAnchor(){let id;try{id=decodeURIComponent(location.hash.slice(1));}catch{return;}const target=document.getElementById(id);if(target?.matches('[data-service]')){applyFilter(target.closest('.services-section'),'all');target.scrollIntoView({behavior:'auto',block:'start'});}}
  let frame=0;
  function updateScroll(){frame=0;$('.site-header')?.classList.toggle('is-scrolled',scrollY>16);const back=$('.back-top');if(back)back.hidden=scrollY<600;const bar=$('.scroll-progress');if(bar){const distance=document.documentElement.scrollHeight-innerHeight;bar.style.transform=`scaleX(${motionAllowed()&&distance>0?Math.min(1,Math.max(0,scrollY/distance)):0})`;}}
  function queueScroll(){if(!frame)frame=requestAnimationFrame(updateScroll);}
  addEventListener('scroll',queueScroll,{passive:true});addEventListener('resize',queueScroll,{passive:true});
  addEventListener('hashchange',revealAnchor);addEventListener('load',()=>{revealAnchor();updateScroll();},{once:true});
  matchMedia('(min-width:1151px)').addEventListener('change',e=>{if(e.matches)closeMenu();});
  motionPreference.addEventListener('change',()=>init());
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>$$('.reveal',event.target).forEach(el=>observer?.unobserve(el)));
  document.addEventListener('shopify:section:select',event=>{$$('.reveal',event.target).forEach(el=>el.classList.add('is-visible'));});
  init();setInterval(hours,60000);
})();
